import { Link } from "react-router-dom";

const categoryLinks = [
  { label: "都市情感", to: "/category?type=都市" },
  { label: "古装权谋", to: "/category?type=古装" },
  { label: "悬疑犯罪", to: "/category?type=悬疑" },
  { label: "历史正剧", to: "/category?type=历史" },
  { label: "青春校园", to: "/category?type=青春" },
];

const siteLinks = [
  { label: "首页", to: "/" },
  { label: "电视剧分类", to: "/category" },
  { label: "影视资讯", to: "/news" },
  { label: "搜索剧集", to: "/search" },
  { label: "关于我们", to: "/about" },
];

export default function Footer() {
  return (
    <footer className="mt-auto w-full bg-primary-900 text-primary-100">
      <div className="w-full px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-500 text-primary-950">
                <i className="ri-book-marked-line text-xl"></i>
              </span>
              <span className="font-heading text-lg font-bold text-background-50">善良的秘书</span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-primary-200">
              一个专注电视剧资源索引与剧情介绍的门户平台，聚合热门剧集、主演名单与影视资讯，助你快速了解每一部好戏。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold text-background-50">
              <a href="#footer-nav">站内导航</a>
            </h4>
            <ul className="mt-4 space-y-2.5 text-sm">
              {siteLinks.map((l) => (
                <li key={l.to}>
                  <Link to={l.to} className="text-primary-200 hover:text-accent-400 transition-colors">
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold text-background-50">
              <a href="#footer-cat">热门分类</a>
            </h4>
            <ul className="mt-4 space-y-2.5 text-sm">
              {categoryLinks.map((l) => (
                <li key={l.to}>
                  <Link to={l.to} className="text-primary-200 hover:text-accent-400 transition-colors">
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold text-background-50">
              <a href="#footer-contact">联系我们</a>
            </h4>
            <ul className="mt-4 space-y-3 text-sm text-primary-200">
              <li className="flex items-start gap-2">
                <i className="ri-mail-line mt-0.5 text-base text-accent-400"></i>
                <span>hello@liangshan-mishi.com</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-weibo-line mt-0.5 text-base text-accent-400"></i>
                <span>@善良的秘书官方</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-time-line mt-0.5 text-base text-accent-400"></i>
                <span>周一至周五 10:00 - 18:00</span>
              </li>
            </ul>
            <Link
              to="/about"
              className="mt-4 inline-flex items-center gap-1.5 rounded-md bg-accent-500 px-4 py-2 text-xs font-medium text-primary-950 whitespace-nowrap cursor-pointer hover:bg-accent-400 transition-colors"
            >
              <i className="ri-feedback-line"></i>
              意见反馈
            </Link>
          </div>
        </div>

        <div className="mt-10 flex flex-col sm:flex-row items-center justify-between gap-3 border-t border-primary-800 pt-6 text-xs text-primary-300">
          <p>© 2024 善良的秘书 · 本站内容为演示性质，影视资料仅供索引与介绍。</p>
          <p className="flex items-center gap-4">
            <span>资源索引</span>
            <span>剧情介绍</span>
            <span>演员资讯</span>
          </p>
        </div>
      </div>
    </footer>
  );
}